import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ShowToastPayload, ToastState } from './toastTypes';

const initialState: ToastState = {
  queue: []
};

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast: (state, action: PayloadAction<ShowToastPayload>) => {
      const { onAction, type, message, actionLabel } = action.payload;

      state.queue.push({ type, message, showAction: !!onAction, actionLabel });
    },
    hideToast: state => {
      if (state.queue.length > 0) {
        state.queue = state.queue.slice(1);
      }
    }
  }
});

export const toastReducer = toastSlice.reducer;

export const { showToast, hideToast } = toastSlice.actions;

export const toastAction = createAction('toast/action');
